import { CheckCircle } from "lucide-react";

const features = [
  "Mobile service - we come to you",
  "Eco-friendly cleaning products",
  "Experienced & insured professionals",
  "Satisfaction guaranteed",
];

export default function About() {
  return (
    <section 
      id="about" 
      className="section-padding bg-white"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative" data-testid="about-image-container">
            <div className="aspect-[4/3] bg-[#0B1E36] relative overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1770566258216-e14620ad225e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMHdoaXRlJTIwc3BlZWRib2F0JTIwbGFrZXxlbnwwfHx8fDE3NzUyNTkzNzR8MA&ixlib=rb-4.1.0&q=85"
                alt="Shiny speedboat on water"
                className="w-full h-full object-cover opacity-90"
                data-testid="about-image"
              />
            </div>
            {/* Accent Block */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#FACC15] hidden lg:block" />
          </div>

          {/* Content Side */}
          <div data-testid="about-content">
            <span 
              className="inline-block text-xs tracking-[0.2em] uppercase font-bold text-[#64748B] mb-4"
              data-testid="about-label"
            >
              About Us
            </span>
            <h2 
              className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#0B1E36] tracking-tight mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid="about-heading"
            >
              We Bring The Clean To You
            </h2>
            <p 
              className="text-[#64748B] leading-relaxed mb-8"
              data-testid="about-description"
            >
              At Deep Clean Detailers, we understand that your boat is more than just a vessel - it's your escape, your investment, and your pride. That's why we bring professional-grade detailing services directly to your dock, marina, or driveway.
            </p>
            <p 
              className="text-[#64748B] leading-relaxed mb-8"
              data-testid="about-description-2"
            >
              With years of experience in marine detailing, our team uses only the best products and techniques to ensure your boat looks its absolute best, while protecting it from the harsh marine environment.
            </p>

            {/* Features List */}
            <ul className="space-y-4" data-testid="about-features">
              {features.map((feature, index) => (
                <li 
                  key={index} 
                  className="flex items-center gap-3"
                  data-testid={`about-feature-${index}`}
                >
                  <CheckCircle className="w-5 h-5 text-[#FACC15] flex-shrink-0" />
                  <span className="text-[#0F172A] font-medium">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
